import { z } from 'zod'

import { DateZod } from '../common'

export const ConfigurationRegistrationZod = z.object({
  startDate: DateZod.nullable(),
})
